import { call, select, put } from 'redux-saga/effects';
import { reportJSError } from '@/utils/common';
import getTestVersionSamService from '@/services/getTestVersionSam';
import { actions as samActions } from '@/reducers/sam-reducer';

const context = (state) => state.main.context;

export function* getTestVersionSam({ payload }) {
  const contextApi = yield select(context);
  try {
    const { data } = payload;
    const { testName } = { ...data };
    if (testName) {
      const testResult = yield call(getTestVersionSamService, {
        context: contextApi,
        data: {
          ic_version_test: testName,
          referal_ap: window.location.href,
        },
      });
      yield put(
        samActions.getTestVersionSamSuccess({
          result: testResult.find((item) => item.ruleName === testName)
            ?.actionName,
        })
      );
    } else {
      yield put(
        samActions.getTestVersionSamSuccess({
          result: 'NO-TEST',
        })
      );
    }
  } catch (error) {
    yield put(
      samActions.getTestVersionSamError({
        result: 'A',
      })
    );
    reportJSError(
      error,
      'testAB',
      'sagas/sam/get-test-version-sam',
      contextApi
    );
  }
}
